import { gsap } from 'gsap';
import jQuery from "jquery";
import { PageHandler } from './PageHandler';
import { Utils } from '../misc/Utils';

export class SeminarsPageHandler extends PageHandler {
    constructor(id) {
    	super(id);
        this.seminars = [];
        this.tableId = "wpdtSimpleTable-2"
        this.mainElemId = "seminars"
    }

    storeWPDataTableData() {
        let i, numRows = document.getElementById(this.tableId).getAttribute('data-column');

        for (i = 0; i < numRows; i++)
            this.seminars[i] = {title: "", description: "", items: []};

        document.querySelectorAll('.wpdt-cell[data-row-index="0"]').forEach((elem,index) => { 
            var col = elem.getAttribute('data-col-index')
            this.seminars[col]['title'] = elem.textContent.trim();
        })
        document.querySelectorAll('.wpdt-cell[data-row-index="1"]').forEach((elem,index) => { 
            var col = elem.getAttribute('data-col-index')
            this.seminars[col]['description'] = elem.textContent.trim();
        })

        document.querySelectorAll('.wpdt-cell').forEach((elem,index) => { 
            var row = elem.getAttribute('data-row-index')
            var col = elem.getAttribute('data-col-index')
            var text = elem.textContent.trim();
            if (text !== "" && row > 1) 
                this.seminars[col].items.push(text);
        })
    }

    buildSeminarsDiv() {
        let $pane = jQuery('main#seminars .section-content__pane')
        this.seminars.forEach((elem, index) => {
            var title = elem.title;
            var description = elem.description;
            var items = elem.items;
            var itemsTemplate = ``;
            items.forEach((elem, index) => {
                itemsTemplate += `<div class="seminar-item">${elem}</div>`
            })
			var $container = jQuery(`<div class="section-content__pane-row"></div>`)
            $container.append(jQuery(`<h3 class="section-content__pane-title">${title}</h3>`))
            $container.append(jQuery(`<div class="section-content__pane-description">${description}</div>`))
            $container.append(jQuery(`<div class="section-content__pane-items">${itemsTemplate}</div>`))
			$pane.append($container);
        })
    }

    init() {
		this.storeWPDataTableData();
		this.buildSeminarsDiv();

		gsap.fromTo('.section-content__pane', {autoAlpha: 0, y: 100}, {autoAlpha: 1, y: 0, duration: 0.7})
    }

    ajax() {
	
	}

    destroy() {
    
    }

	events() {
		
	}

	transitions() {
		Utils.fadeInUp('.seminars .section-content')

		// gsap.fromTo('.seminars .intro', {backgroundSize: "600%"}, {backgroundSize: "100%", duration: 0.5, ease: 'power2.inout'});
		
	}
}